import React from "react";
import ReactApexChart from "react-apexcharts";

export default function SpineChart({ dataColors, y, xaxis }) {
  const series = y || [];

  const options = {
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    colors: dataColors || ["#008FFB", "#00E396"],
    xaxis: {
      categories: xaxis || [],
    },
    grid: {
      borderColor: "#f1f1f1",
    },
    tooltip: {
      x: {
        show: false, // Supprime l'affichage des dates inutiles
      },
    },
    chart: {
      toolbar: {
        show: false, // Désactive la barre d'outils avec les icônes
      },
    },
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="area"
      height="200"
    />
  );
}
